var exports = {
  "iE": "xaee3c4fa--0e476b--wrapper",
  "A4": "xaee3c4fa--0e476b--control",
  "C3": "xaee3c4fa--0e476b--back-image",
};

module.exports = exports;
